export const API_REVISION_ROUTES = {
  REVISIONS: '/revisions',
  REVISION: '/revisions/:revisionId',
  REVISION_UPDATE: '/revisions/:revisionId/update',
};
